import TagInput from './TagInput.jsx';

export default TagInput;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarLarge/TagInput/index.js